import React, { useState } from "react";
import PropTypes from "prop-types";
import FileHistoryComponent from "./FileHistoryComponent";
import { useQueryWithSimpleErrorHandling } from "hooks";
import { DMS_FILES_INFO } from "../queries";

const FileHistoryContainer = ({ fileId, docType, onDownloadFile, onCloseModal }) => {
  const [files, setFiles] = useState([]);

  const { loading } = useQueryWithSimpleErrorHandling(DMS_FILES_INFO, {
    variables: { fileId },
    fetchPolicy: "network-only",
    onCompleted: ({ dmsFilesInfo }) => {
      setFiles(dmsFilesInfo);
    }
  });

  return (
    <FileHistoryComponent
      loading={loading}
      files={files}
      docType={docType}
      onDownloadFile={onDownloadFile}
      onCloseModal={onCloseModal}
    />
  );
};

FileHistoryContainer.propTypes = {
  fileId: PropTypes.string,
  docType: PropTypes.string,
  onDownloadFile: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired
};

export default FileHistoryContainer;
